import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

export default function (selector = '.js-swiper-comparison') {

  function initSwiper(element) {

    let defaultSettings = {
      slidesPerView: 3,
      spaceBetween: 15,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        820: {
          slidesPerView: 3,
        },
      },
    }

    return new Swiper(element, defaultSettings);
  }

  document.querySelectorAll(selector).forEach((element) => {
    initSwiper(element);
  });
}
